import {IBizChallenge, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {AChallenge} from "@/views/editor/service/challenge/challenge";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {IGift} from "@/model/materials/gifts";

interface IPGift extends IGift {
    count: number
}
export interface IPraiseMeta {
    gifts: IPGift[];
    props: {
        join_condition: 'none' | 'sign'
        pass_condition: 'view' | 'sign'
    }
}

export class Praise extends AChallenge implements IBizChallenge {
    readonly opt: IPraiseMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IPraiseMeta
    }

    resetMeta(): IBusiness {
        const opt: IPraiseMeta = {gifts: [], props: {join_condition: 'sign', pass_condition: 'view'}}
        Object.assign(this.opt, opt)
        return this;
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return []
    }
}